import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-locked',
  templateUrl: './locked.component.html',
  styleUrls: ['./locked.component.scss'],
})
export class LockedComponent implements OnInit {
  @Input() page;
  contentMap: any = {
    forum: {
      img: '../../../assets/img/locked/locked-forum.svg',
      title: 'Sign up to view discussions on CDR Community solutions',
    },
    resources: {
      img: '../../../assets/img/locked/locked-resources.svg',
      title: 'Sign up to get access to resources on CDR Community solutions',
    },
    members: {
      img: '../../../assets/img/locked/locked-forum.svg',
      title: 'Sign up to connect with CDR Community members',
    },
    institutions: {
      img: '../../../assets/img/locked/locked-resources.svg',
      title: 'Sign up to get access to institutions related to CDR Community solutions',
    },
    projects: {
      img: '../../../assets/img/locked/locked-resources.svg',
      title: 'Sign up to get access to projects related to CDR Community solutions',
    },
    jobs: {
      img: '../../../assets/img/locked/locked-resources.svg',
      title: 'Sign up to get access to jobs related to CDR Community solutions',
    },
    events: {
      img: '../../../assets/img/locked/locked-resources.svg',
      title: 'Sign up to get access to events related to CDR Community solutions',
    },
  };
  redirectPath = '';
  
  constructor(
    private router: Router
  ) {}

  ngOnInit() {
    this.redirectPath = window.location.pathname;
    console.log(window.location.pathname);
    // http://localhost:4200/forum/9N0G5EO0lyJ12jmEoPFb
  }
}
